import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login as loginService } from "../services/auth";

export default function Login() {
  const navigate = useNavigate();
  const [identification, setIdentification] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { token, user } = await loginService(identification, password);

      if (!token) throw new Error("Respuesta inválida del servidor (sin token).");

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      navigate("/");
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "Servidor no disponible";
      alert("Error al iniciar sesión: " + msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* Capa oscura con imagen */}
      <div className="absolute left-0 w-full h-full bg-black opacity-80 z-0">
        <img
          src="/img/backFondo.webp"
          alt="Background"
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* Contenido */}
      <div className="absolute inset-0 flex items-center justify-center z-10">
        <form
          onSubmit={handleLogin}
          className="bg-white p-8 rounded shadow-xl w-full max-w-sm flex flex-col gap-4"
        >
          <img src="/img/logoCloudtainerAzul.svg" alt="logo" className="h-30" />
          <h2 className="text-2xl font-semibold text-center text-[#1D60F3]">
            Iniciar sesión
          </h2>

          <input
            type="text"
            placeholder="Identificación"
            value={identification}
            onChange={(e) => setIdentification(e.target.value)}
            className="border rounded px-4 py-2"
            required
          />

          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="border rounded px-4 py-2"
            required
          />

          <button
            type="submit"
            disabled={submitting}
            className="bg-[#1D60F3] text-white py-2 rounded hover:bg-[#1d61f3db] disabled:opacity-60"
          >
            {submitting ? "Entrando…" : "Iniciar sesión"}
          </button>
        </form>
      </div>
    </div>
  );
}